module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/radio_button.059e7bf9.svg";